import { render, staticRenderFns } from "./goodsAddress1.vue?vue&type=template&id=20c24f8d&scoped=true&"
import script from "./goodsAddress1.vue?vue&type=script&lang=js&"
export * from "./goodsAddress1.vue?vue&type=script&lang=js&"
import style0 from "./goodsAddress1.vue?vue&type=style&index=0&id=20c24f8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c24f8d",
  null
  
)

export default component.exports